<template>
  <i-select :value="value" :clearable="true" @input="input">
    <i-option
      v-for="(item, key) in destinations"
      :key="key"
      :value="item"
      :label="$t(`pbx.stat.common.field.${item}`)"
    />
  </i-select>
</template>

<script>
  const destinations = ['internal', 'external'];
  export default {
    props: {
      value: {
        type: String,
        default: '',
        validator: function(value) {
          if (value) {
            return destinations.indexOf(value) !== -1;
          }
          return true;
        }
      }
    },
    data: () => ({ destinations: destinations }),
    methods: {
      input(val) {
        this.$emit('input', val);
      }
    }
  };
</script>
